import NewsComp from "../../components/news/NewsComp"
import { useTranslation } from "react-i18next"

export default function News006() {

    const { t } = useTranslation()

    const newsText = [
        t('news:news.6.p1'),
        t('news:news.6.p2'),
        t('news:news.6.p3'),
        t('news:news.6.p4')
    ]

    const newsImage = [
        "news006-img1.jpg",
        "news006-img2.jpg",
        "news006-img3.jpg",
        "news006-img4.jpg"
    ]
    return (
        <div>
            <NewsComp
                newsImage={newsImage}
                newsText={newsText}
                date="2021-04-02"
                headline={t('news:headline.6')}
            />
        </div>
    )
}
